import { useStoreState } from 'easy-peasy'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

export default function Container ({ children }) {
  const router = useRouter()
  const { search } = router.query
  const state = useStoreState(s => ({
    products: s.products
  }))

  const [results, setResults] = useState([])

  useEffect(() => {
    const { status, payload } = state.products
    if (status === 2) {
      setResults(payload.results)
    }
  }, [state.products])

  return children({
    state,
    results,
    search
  })
}
